import React from 'react';
import { Box, Select, MenuItem, Typography, Pagination, FormControl } from '@mui/material';

interface PaginationControlsProps {
  total: number;
  page: number;
  limit: number;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: number) => void;
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  total,
  page,
  limit,
  onPageChange,
  onLimitChange,
}) => {
  const totalPages = Math.ceil(total / limit);
  const startItem = total === 0 ? 0 : (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, total);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 2,
        py: 2,
        px: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Exibir
        </Typography>
        <FormControl size="small">
          <Select
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            sx={{ minWidth: 80 }}
          >
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>
        <Typography variant="body2" color="text.secondary">
          por página
        </Typography>
      </Box>

      <Typography variant="body2" color="text.secondary">
        Mostrando {startItem} - {endItem} de {total} registros
      </Typography>

      {totalPages > 1 && (
        <Pagination
          count={totalPages}
          page={page}
          onChange={(_, value) => onPageChange(value)}
          color="primary"
          size="small"
          sx={{
            '& .MuiPaginationItem-root.Mui-selected': {
              bgcolor: '#C23535',
              '&:hover': { bgcolor: '#A52A2A' },
            },
          }}
        />
      )}
    </Box>
  );
};
